// Preference constants — in a zero-dependency file to break the circular
// dependency between helpers/preference.tsx ↔ apollo/preference.ts.
// Do NOT add imports here.

export enum TSUBAKI_PROMPT_HELPER_VALUE {
  autoEnable = 'autoEnable',
  followUser = 'followUser',
}

export enum TSUBAKI2_PROMPT_HELPER_VALUE {
  autoEnable = 'autoEnable',
  followUser = 'followUser',
}

export const genderOptions = ['male', 'female', 'other'] as const
export type Gender = (typeof genderOptions)[number]

export const promptStyleOptions = ['natural-language', 'precise-tags'] as const
export type PromptStyle = (typeof promptStyleOptions)[number]

export type ExperienceLevel = 'beginner' | 'intermediate' | 'advanced'
